__turbopack_context__.v({
  "input": "FormInput-module-scss-module__9GsdCa__input",
  "input-container": "FormInput-module-scss-module__9GsdCa__input-container",
  "input-error": "FormInput-module-scss-module__9GsdCa__input-error",
  "input-type-checkbox": "FormInput-module-scss-module__9GsdCa__input-type-checkbox",
  "input-type-radio": "FormInput-module-scss-module__9GsdCa__input-type-radio",
  "label": "FormInput-module-scss-module__9GsdCa__label",
});
